import { render, staticRenderFns } from "./OcaEdit.vue?vue&type=template&id=0fb651f6&"
import script from "./OcaEdit.vue?vue&type=script&lang=js&"
export * from "./OcaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports